import React from 'react';
import RatingPointHistoryTable from './RatingPointHistoryTable';
import groupsSearchItem from '../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchItem';

const GroupsSearchItem = groupsSearchItem(RatingPointHistoryTable);

export default props => (
  <GroupsSearchItem
    {...props}
    groupName="userRatingPointsHistoryList"
    listReduceName="userRatingModule.lists.userRatingPointsHistoryList"
  />
);



// WEBPACK FOOTER //
// ./src/components/Rating/RatingPointHistoryTable/index.js